import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MedicaidService } from '../+products/medicaid/medicaid.service';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { SSIService } from '../+products/ssi/ssi.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';


@Injectable()
export class InterviewSSIDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        ssiService: SSIService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService,
        private medicaidService: MedicaidService
    ) {
        super(store, ssiService, productOrchestratorService, appInsightsService);
    }

    async generateContextData(contextData: any, input?: any) {

        return {
            ...(await super.generateContextData(contextData)),
            MedicaidProductType: this.medicaidService.sourceProductSync?.name ?? "NO_CASE"
        };
    }
}
